"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DraftsIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.501 10.865a.46.46 0 01-.086-.53l.79-1.579 3.28-3.28-.002-.002 1.238-1.237.002.001 1.106-1.106 1.406 1.406-1.145 1.145.003.003-1.244 1.244-.003-.003-3.235 3.235-1.579.79a.46.46 0 01-.53-.087zm8.203-6.796l-1.406-1.406.469-.47a.663.663 0 01.937 0l.468.47a.663.663 0 01.004.934l-.004.003-.468.469zM9.355 2.796l.592.624-1.238 1.238L8.085 4c-.18-.19-.366-.25-.51-.25H4.117v8.5h7V8.256l1.56-1.56c.124.351.19.73.19 1.118V12.5c0 .828-.588 1.5-1.313 1.5H3.68c-.725 0-1.312-.672-1.312-1.5v-9c0-.828.587-1.5 1.312-1.5h3.896c.66 0 1.295.284 1.78.796zM4.117 3.5z",
    clipRule: "evenodd"
  })))
});
DraftsIcon.displayName = 'DraftsIcon';
var _default = exports.default = DraftsIcon;